export enum ZoomEventKeyEnum {
  WEBINAR_STARTED = 'webinar-started',
  WEBINAR_ENDED = 'webinar-ended'
}
